// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../dist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../dist/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../dist/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/IRANSansWeb_Light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./fonts/IRANSansWeb_Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./fonts/IRANSansWebFaNum.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./fonts/IRANSansWebFaNumBold.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * @NOTE: Prepend a \`~\` to css file paths that are in your node_modules
 *        See https://github.com/webpack-contrib/sass-loader#imports
 */
@font-face {
  font-family: "IranSans_Light";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff");
  font-style: normal;
  font-weight: normal;
  font-display: swap;
}
@font-face {
  font-family: "IranSans_Bold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff");
  font-style: normal;
  font-weight: normal;
  font-display: swap;
}
@font-face {
  font-family: "IranSansFaNum";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff");
  font-style: normal;
  font-weight: normal;
  font-display: swap;
}
@font-face {
  font-family: "IranSansFaNumBold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff");
  font-style: normal;
  font-weight: normal;
  font-display: swap;
}
body {
  /* direction:rtl; */
  font-family: IranSans_Light;
  position: relative;
  height: 100vh;
  /* background: linear-gradient(
    200.96deg,
    #fedc2a -29.09%,
    #dd5789 51.77%,
    #7a2c9e 129.35%
  ); */
  /* background: linear-gradient(
    200.96deg,
    #eee -29.09%,
    #fff 51.77%,
    #eee 129.35%
  ); */
  /* font-family: sans-serif; */
  overflow-y: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

input::placeholder,
textarea::placeholder {
  font-family: IranSans_Light;
}

.reloadMargin {
  margin: 0 10px;
}

.infinite-scroll-component__outerdiv {
  width: 100% !important;
}

.infinite-scroll-component {
  overflow: unset !important;
  flex-direction: row;
  flex-wrap: wrap;
  display: flex;
}

.lastMessage {
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -moz-text-size-adjust: auto;
  margin-left: 5px;
}

.maxWidth100 {
  max-width: 100% !important;
  white-space: pre-wrap;
  word-break: break-all;
}

.w80px {
  width: 80px;
}

.h80px {
  height: 80px;
}

.left0 {
  left: 0px !important;
}

.chatbarUsername {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -moz-text-size-adjust: auto;
}

.p-0 {
  padding: 0px !important;
}

.pr-0 {
  padding-right: 0 !important;
}

.br-0 {
  border-right: unset !important;
}

.bl-0 {
  border-left: unset !important;
}

.pl-0 {
  padding-left: 0px;
}

.pr-1 {
  padding-right: 5px;
}

.px-1 {
  padding: 0 5px;
}

.hiddenAudioContainer {
  visibility: hidden;
}

.rtl {
  direction: rtl;
}
.rtl .mr-auto {
  margin-right: auto;
}
.rtl .ml-auto {
  margin-left: auto;
}
.rtl .ml-10 {
  margin-left: 10px;
}
.rtl .mr-10 {
  margin-right: 10px;
}
.rtl .flex-row {
  flex-direction: row;
}
.rtl .flex-row-reverse {
  flex-direction: row-reverse;
}

.flex-row {
  flex-direction: row;
}

.flex-row-reverse {
  flex-direction: row-reverse;
}

.ltr {
  direction: ltr;
}
.ltr .mr-auto {
  margin-left: auto !important;
  margin-right: unset !important;
}
.ltr .ml-auto {
  margin-right: auto !important;
  margin-left: unset !important;
}
.ltr .mr-10 {
  margin-left: 10px;
}
.ltr .ml-10 {
  margin-right: 10px;
}

.textWhite {
  color: #ffffff !important;
}

button {
  font-family: IranSans_Light;
}

.inputError {
  padding: 0 5px;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #ff9315 !important;
}

.moreIcon {
  width: auto;
  height: auto;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  color: unset !important;
  filter: unset !important;
}

#root {
  width: 100%;
  height: inherit;
}

.infinite-scroll-component {
  overflow: unset !important;
}

.makeWhite {
  color: #000000 !important;
  filter: brightness(0) invert(1) !important;
}

.makeBlack {
  filter: brightness(0) invert(0) !important;
}

.flex {
  display: flex;
}

.flex-col {
  flex-direction: column;
}

.flex-col-reverse {
  flex-direction: column-reverse;
}

.justify-start {
  justify-content: flex-start;
}

.justify-center {
  justify-content: center;
}

.justify-end {
  justify-content: flex-end;
}

.justify-between {
  justify-content: space-between;
}

.justify-around {
  justify-content: space-around;
}

.items-start {
  align-items: flex-start;
}

.items-center {
  align-items: center;
}

.items-end {
  align-items: flex-end;
}

.items-between {
  align-items: space-between;
}

.items-around {
  align-items: space-around;
}

.flex-wrap {
  flex-wrap: wrap;
}

.box-border {
  box-sizing: border-box;
}

.white-color {
  color: #fff;
}

.black-color {
  color: #1F6400;
}

.hover-color {
  color: #1F6400;
}

.hover-bg-color {
  background-color: #1F6400;
}

.theme-color {
  color: #1F6400 !important;
}

.theme-bg-color {
  background-color: #1F6400;
}

.theme-second-color {
  background-color: #1F6400;
}

.theme-border {
  border: 1px solid #1F6400;
}

.text-underline {
  text-decoration: underline;
}

.second-color {
  color: #1F6400 !important;
}

.second-bg {
  background-color: #1F6400;
}

.bold {
  font-weight: bold !important;
}

.w-auto {
  width: auto;
}

.w-full {
  width: 100%;
}

.w-100vw {
  width: 100vw;
}

.h-auto {
  height: auto;
}

.h-full {
  height: 100%;
}

.h-400px {
  height: 400px;
}

.h-100vh {
  height: 100vh;
}

.relative {
  position: relative;
}

.absolute {
  position: absolute;
}

.top-0 {
  top: 0;
}

.left-0 {
  left: 0;
}

.right-0 {
  right: 0;
}

.bottom-0 {
  bottom: 0;
}

.mt-auto {
  margin-top: auto;
}

.mx-auto {
  margin-right: auto !important;
  margin-left: auto !important;
}

.my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important;
}

.cursor-pointer {
  cursor: pointer !important;
}

.cursor-default {
  cursor: default !important;
}

.cursor-zoomIn {
  cursor: zoom-in;
}

.cursor-zoomOut {
  cursor: zoom-out;
}

.hidden {
  display: none;
}

.overflow-hidden {
  overflow: hidden;
}

.zeroOpacity {
  opacity: 0;
}

.zIndex100 {
  z-index: 100;
}

.zIndex-100 {
  z-index: -100;
}

.totalOpacity {
  opacity: 1;
}

.top50 {
  top: 50%;
}

.top100 {
  top: 70px;
}

.overflow-visible {
  overflow: visible;
}

.rotate-180 {
  transform: rotate(180deg) !important;
}

.text-right {
  text-align: right;
}

.text-left {
  text-align: left;
}

.m-auto {
  margin: auto;
}

.mx-8px {
  margin: 0 8px;
}

.right-0 {
  right: 0;
}

.left-0 {
  left: 0;
}

.text-center {
  text-align: center;
}

.mt-10px {
  margin-top: 10px;
}

.light {
  background-color: #ffffff;
}

.grayShadow {
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.09), 0px 1px 5px rgba(0, 0, 0, 0.09);
}

button {
  background-color: white;
  padding: 10px 20px;
  border-radius: 10px;
  border: none;
  appearance: none;
  font-size: 1.3rem;
  box-shadow: 0px 8px 28px -6px rgba(24, 39, 75, 0.12), 0px 18px 88px -4px rgba(24, 39, 75, 0.14);
  transition: all ease-in 0.1s;
  cursor: pointer;
  opacity: 0.9;
}

.mobile-view {
  display: none;
}

button:hover {
  /* transform: scale(1.05); */
  opacity: 1;
}

li {
  list-style: none;
}

a {
  text-decoration: none;
  height: fit-content;
  width: fit-content;
  margin: 10px;
}

a:hover {
  opacity: 1;
  text-decoration: none;
}

.emptyDiv {
  flex: 0.8 1;
}

.wordBreak {
  word-break: break-all;
  text-align: left;
}

.lds_ringWhite {
  display: inline-block;
  position: relative;
  width: 15px;
  height: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 0;
}

.lds_ringWhite div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 14px;
  height: 14px;
  margin: 8px;
  border: 1px solid #eee !important;
  border-radius: 50%;
  animation: lds_ringWhite 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #eee transparent transparent transparent !important;
}

.lds_ringWhite div:nth-child(1) {
  animation-delay: -0.45s;
}

.lds_ringWhite div:nth-child(2) {
  animation-delay: -0.3s;
}

.lds_ringWhite div:nth-child(3) {
  animation-delay: -0.15s;
}

.roundBox {
  border-radius: 50% !important;
}

.roundBox img {
  border-radius: 50% !important;
}

@keyframes lds_ringWhite {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.groupInChatbar {
  position: absolute;
  bottom: -1px;
  width: 14px !important;
  height: 14px !important;
  /* left: 0px; */
  display: flex !important;
  justify-content: center;
  align-items: center;
  padding: 2px;
  /* background-color: #075b52; */
  font-size: 11px;
  border-radius: 50%;
  background-color: #000000;
}

.groupInChatbarRtl {
  left: 0 !important;
  right: unset !important;
}

.groupInChatbarLtr {
  left: unset !important;
  right: 0 !important;
}

@media only screen and (max-width: 800px) {
  .mobile-view {
    display: flex;
  }
  .emptyDiv {
    display: none;
  }
  #chatpage {
    flex: 1 1;
    /* position:absolute;
    top:0;
    right:0; */
    /* background-color: #eee; */
    /* z-index:900; */
  }
  .emptyDiv {
    /* flex: 0.75; */
  }
}
@media only screen and (max-width: 650px) {
  #chatpage {
    /* margin-top:35px !important;
    padding-top:20px; */
  }
}`, "",{"version":3,"sources":["webpack://./../src/renderer/App.scss"],"names":[],"mappings":"AAAA;;;EAAA;AAIA;EACE,6BAAA;EACA,2DAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AACF;AAEA;EACE,4BAAA;EACA,2DAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AAAF;AAGA;EACE,4BAAA;EACA,2DAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AADF;AAIA;EACE,gCAAA;EACA,2DAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AAFF;AAKA;EACE,mBAAA;EACA,2BAAA;EACA,kBAAA;EACA,aAAA;EACA;;;;;MAAA;EAMA;;;;;MAAA;EAMA,6BAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAHF;;AAOA;;EAEE,2BAAA;AAJF;;AAQA;EACE,cAAA;AALF;;AAQA;EACE,sBAAA;AALF;;AAQA;EACE,0BAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;AALF;;AAQA;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;EACA,uBAAA;EACA,4BAAA;EACA,oBAAA;EACA,qBAAA;EACA,2BAAA;EACA,gBAAA;AALF;;AAQA;EACE,0BAAA;EACA,qBAAA;EACA,qBAAA;AALF;;AAQA;EACE,WAAA;AALF;;AAQA;EACE,YAAA;AALF;;AAQA;EACE,oBAAA;AALF;;AAQA;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;EACA,uBAAA;EACA,4BAAA;EACA,oBAAA;EACA,qBAAA;EACA,2BAAA;AALF;;AAQA;EACE,uBAAA;AALF;;AAQA;EACE,2BAAA;AALF;;AAQA;EACE,8BAAA;AALF;;AAQA;EACE,6BAAA;AALF;;AAQA;EACE,iBAAA;AALF;;AAQA;EACE,kBAAA;AALF;;AAQA;EACE,cAAA;AALF;;AAUA;EACE,kBAAA;AAPF;;AAUA;EACE,cAAA;AAPF;AASE;EACE,kBAAA;AAPJ;AAUE;EACE,iBAAA;AARJ;AAWE;EACE,iBAAA;AATJ;AAYE;EACE,kBAAA;AAVJ;AAaE;EACE,mBAAA;AAXJ;AAcE;EACE,2BAAA;AAZJ;;AAgBA;EACE,mBAAA;AAbF;;AAgBA;EACE,2BAAA;AAbF;;AAgBA;EACE,cAAA;AAbF;AAeE;EACE,4BAAA;EACA,8BAAA;AAbJ;AAgBE;EACE,6BAAA;EACA,6BAAA;AAdJ;AAiBE;EACE,iBAAA;AAfJ;AAkBE;EACE,kBAAA;AAhBJ;;AAqBA;EACE,yBAAA;AAlBF;;AAqBA;EACE,2BAAA;AAlBF;;AAqBA;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;AAlBF;;AAsBA;EAEE,WAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EAEA,kBAAA;EACA,uBAAA;EAEA,wBAAA;AArBF;;AAwBA;EAEE,WAAA;EACA,eAAA;AAtBF;;AAyBA;EACE,0BAAA;AAtBF;;AAyBA;EACE,yBAAA;EAEA,0CAAA;AAtBF;;AAyBA;EAEE,0CAAA;AAtBF;;AAyBA;EACE,aAAA;AAtBF;;AAyBA;EACE,sBAAA;AAtBF;;AAyBA;EACE,8BAAA;AAtBF;;AAyBA;EACE,2BAAA;AAtBF;;AAyBA;EACE,uBAAA;AAtBF;;AAyBA;EACE,yBAAA;AAtBF;;AAyBA;EACE,8BAAA;AAtBF;;AAyBA;EACE,6BAAA;AAtBF;;AAyBA;EACE,uBAAA;AAtBF;;AAyBA;EACE,mBAAA;AAtBF;;AAyBA;EACE,qBAAA;AAtBF;;AAyBA;EACE,0BAAA;AAtBF;;AAyBA;EACE,yBAAA;AAtBF;;AAyBA;EACE,eAAA;AAtBF;;AAyBA;EACE,sBAAA;AAtBF;;AAyBA;EACE,WAAA;AAtBF;;AAyBA;EACE,cAAA;AAtBF;;AAyBA;EACE,cAAA;AAtBF;;AAyBA;EACE,yBAAA;AAtBF;;AAyBA;EACE,yBAAA;AAtBF;;AAyBA;EACE,yBAAA;AAtBF;;AAyBA;EACE,yBAAA;AAtBF;;AA2BA;EACE,yBAAA;AAxBF;;AA2BA;EACE,0BAAA;AAxBF;;AA4BA;EACE,yBAAA;AAzBF;;AA4BA;EACE,yBAAA;AAzBF;;AA4BA;EACE,4BAAA;AAzBF;;AA4BA;EACE,WAAA;AAzBF;;AA4BA;EACE,WAAA;AAzBF;;AA4BA;EACE,YAAA;AAzBF;;AA4BA;EACE,YAAA;AAzBF;;AA4BA;EACE,YAAA;AAzBF;;AA4BA;EACE,aAAA;AAzBF;;AA4BA;EACE,aAAA;AAzBF;;AA4BA;EACE,kBAAA;AAzBF;;AA4BA;EACE,kBAAA;AAzBF;;AA4BA;EACE,MAAA;AAzBF;;AA4BA;EACE,OAAA;AAzBF;;AA4BA;EACE,QAAA;AAzBF;;AA4BA;EACE,SAAA;AAzBF;;AA4BA;EACE,gBAAA;AAzBF;;AA4BA;EACE,6BAAA;EACA,4BAAA;AAzBF;;AA4BA;EACE,2BAAA;EACA,8BAAA;AAzBF;;AA4BA;EACE,0BAAA;AAzBF;;AA4BA;EACE,0BAAA;AAzBF;;AA4BA;EACE,eAAA;AAzBF;;AA4BA;EACE,gBAAA;AAzBF;;AA4BA;EACE,aAAA;AAzBF;;AA4BA;EACE,gBAAA;AAzBF;;AA4BA;EACE,UAAA;AAzBF;;AA4BA;EACE,YAAA;AAzBF;;AA4BA;EACE,aAAA;AAzBF;;AA4BA;EACE,UAAA;AAzBF;;AA4BA;EACE,QAAA;AAzBF;;AA4BA;EACE,SAAA;AAzBF;;AA4BA;EACE,iBAAA;AAzBF;;AA4BA;EACE,oCAAA;AAzBF;;AA4BA;EACE,iBAAA;AAzBF;;AA4BA;EACE,gBAAA;AAzBF;;AA4BA;EACE,YAAA;AAzBF;;AA4BA;EACE,aAAA;AAzBF;;AA8BA;EACE,QAAA;AA3BF;;AA8BA;EACE,OAAA;AA3BF;;AA8BA;EACE,kBAAA;AA3BF;;AA8BA;EACE,gBAAA;AA3BF;;AA8BA;EACE,yBAAA;AA3BF;;AA+BA;EAEE,4EAAA;AA7BF;;AAiCA;EACE,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,+FAAA;EAEA,4BAAA;EACA,eAAA;EACA,YAAA;AA/BF;;AAkCA;EACE,aAAA;AA/BF;;AAkCA;EACE,4BAAA;EACA,UAAA;AA/BF;;AAkCA;EACE,gBAAA;AA/BF;;AAkCA;EACE,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;AA/BF;;AAkCA;EACE,UAAA;EACA,qBAAA;AA/BF;;AAkCA;EACE,WAAA;AA/BF;;AAkCA;EACE,qBAAA;EACA,gBAAA;AA/BF;;AAkCA;EACE,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EAEA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AAhCF;;AAoCA;EACE,sBAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,iCAAA;EACA,kBAAA;EACA,mEAAA;EACA,iEAAA;AAjCF;;AAoCA;EACE,uBAAA;AAjCF;;AAoCA;EACE,sBAAA;AAjCF;;AAoCA;EACE,uBAAA;AAjCF;;AAoCA;EACE,6BAAA;AAjCF;;AAoCA;EACE,6BAAA;AAjCF;;AAqCA;EACE;IACE,uBAAA;EAlCF;EAqCA;IACE,yBAAA;EAnCF;AACF;AAsCA;EAKE,kBAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,eAAA;EACA,wBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EAEA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;AAzCF;;AA6CA;EACE,kBAAA;EACA,uBAAA;AA1CF;;AA6CA;EACE,sBAAA;EACA,mBAAA;AA1CF;;AA6CA;EACE;IACE,aAAA;EA1CF;EA6CA;IACE,aAAA;EA3CF;EA8CA;IACE,SAAA;IACA;;cAAA;IAGA,4BAAA;IACA,iBAAA;EA5CF;EA+CA;IACE,gBAAA;EA7CF;AACF;AAgDA;EACE;IACE;uBAAA;EA7CF;AACF","sourcesContent":["/*\n * @NOTE: Prepend a `~` to css file paths that are in your node_modules\n *        See https://github.com/webpack-contrib/sass-loader#imports\n */\n@font-face {\n  font-family: 'IranSans_Light';\n  src: url('./fonts/IRANSansWeb_Light.woff') format('woff');\n  font-style: normal;\n  font-weight: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'IranSans_Bold';\n  src: url('./fonts/IRANSansWeb_Bold.woff') format('woff');\n  font-style: normal;\n  font-weight: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'IranSansFaNum';\n  src: url('./fonts/IRANSansWebFaNum.woff') format('woff');\n  font-style: normal;\n  font-weight: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'IranSansFaNumBold';\n  src: url('./fonts/IRANSansWebFaNumBold.woff') format('woff');\n  font-style: normal;\n  font-weight: normal;\n  font-display: swap;\n}\n\nbody {\n  /* direction:rtl; */\n  font-family: IranSans_Light;\n  position: relative;\n  height: 100vh;\n  /* background: linear-gradient(\n    200.96deg,\n    #fedc2a -29.09%,\n    #dd5789 51.77%,\n    #7a2c9e 129.35%\n  ); */\n  /* background: linear-gradient(\n    200.96deg,\n    #eee -29.09%,\n    #fff 51.77%,\n    #eee 129.35%\n  ); */\n  /* font-family: sans-serif; */\n  overflow-y: hidden;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n// .test-[500]\ninput::placeholder,\ntextarea::placeholder {\n  font-family: IranSans_Light;\n\n}\n\n.reloadMargin {\n  margin: 0 10px;\n}\n\n.infinite-scroll-component__outerdiv {\n  width: 100% !important;\n}\n\n.infinite-scroll-component {\n  overflow: unset !important;\n  flex-direction: row;\n  flex-wrap: wrap;\n  display: flex;\n}\n\n.lastMessage {\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  word-break: break-all;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  -webkit-box-orient: vertical;\n  display: -webkit-box;\n  -webkit-line-clamp: 1;\n  -moz-text-size-adjust: auto;\n  margin-left: 5px;\n}\n\n.maxWidth100 {\n  max-width: 100% !important;\n  white-space: pre-wrap;\n  word-break: break-all;\n}\n\n.w80px {\n  width: 80px;\n}\n\n.h80px {\n  height: 80px;\n}\n\n.left0 {\n  left: 0px !important;\n}\n\n.chatbarUsername {\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  word-break: break-all;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  -webkit-box-orient: vertical;\n  display: -webkit-box;\n  -webkit-line-clamp: 1;\n  -moz-text-size-adjust: auto;\n}\n\n.p-0 {\n  padding: 0px !important;\n}\n\n.pr-0 {\n  padding-right: 0 !important;\n}\n\n.br-0 {\n  border-right: unset !important;\n}\n\n.bl-0 {\n  border-left: unset !important;\n}\n\n.pl-0 {\n  padding-left: 0px;\n}\n\n.pr-1 {\n  padding-right: 5px;\n}\n\n.px-1 {\n  padding: 0 5px;\n}\n\n.infinite-scroll-component__outerdiv {}\n\n.hiddenAudioContainer {\n  visibility: hidden;\n}\n\n.rtl {\n  direction: rtl;\n\n  .mr-auto {\n    margin-right: auto;\n  }\n\n  .ml-auto {\n    margin-left: auto;\n  }\n\n  .ml-10 {\n    margin-left: 10px;\n  }\n\n  .mr-10 {\n    margin-right: 10px;\n  }\n\n  .flex-row {\n    flex-direction: row;\n  }\n\n  .flex-row-reverse {\n    flex-direction: row-reverse;\n  }\n}\n\n.flex-row {\n  flex-direction: row;\n}\n\n.flex-row-reverse {\n  flex-direction: row-reverse;\n}\n\n.ltr {\n  direction: ltr;\n\n  .mr-auto {\n    margin-left: auto !important;\n    margin-right: unset !important;\n  }\n\n  .ml-auto {\n    margin-right: auto !important;\n    margin-left: unset !important;\n  }\n\n  .mr-10 {\n    margin-left: 10px;\n  }\n\n  .ml-10 {\n    margin-right: 10px;\n  }\n\n}\n\n.textWhite {\n  color: #ffffff !important;\n}\n\nbutton {\n  font-family: IranSans_Light;\n}\n\n.inputError {\n  padding: 0 5px;\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: #ff9315 !important;\n\n}\n\n.moreIcon {\n\n  width: auto;\n  height: auto;\n  cursor: pointer;\n  padding: 4px;\n\n  border-radius: 4px;\n  color: unset !important;\n  -webkit-filter: unset !important;\n  filter: unset !important;\n}\n\n#root {\n\n  width: 100%;\n  height: inherit;\n}\n\n.infinite-scroll-component {\n  overflow: unset !important;\n}\n\n.makeWhite {\n  color: #000000 !important;\n  -webkit-filter: brightness(0) invert(1) !important;\n  filter: brightness(0) invert(1) !important;\n}\n\n.makeBlack {\n  -webkit-filter: brightness(0) invert(0) !important;\n  filter: brightness(0) invert(0) !important;\n}\n\n.flex {\n  display: flex;\n}\n\n.flex-col {\n  flex-direction: column;\n}\n\n.flex-col-reverse {\n  flex-direction: column-reverse;\n}\n\n.justify-start {\n  justify-content: flex-start;\n}\n\n.justify-center {\n  justify-content: center;\n}\n\n.justify-end {\n  justify-content: flex-end;\n}\n\n.justify-between {\n  justify-content: space-between;\n}\n\n.justify-around {\n  justify-content: space-around;\n}\n\n.items-start {\n  align-items: flex-start;\n}\n\n.items-center {\n  align-items: center;\n}\n\n.items-end {\n  align-items: flex-end;\n}\n\n.items-between {\n  align-items: space-between;\n}\n\n.items-around {\n  align-items: space-around;\n}\n\n.flex-wrap {\n  flex-wrap: wrap;\n}\n\n.box-border {\n  box-sizing: border-box;\n}\n\n.white-color {\n  color: #fff;\n}\n\n.black-color {\n  color: #1F6400;\n}\n\n.hover-color {\n  color: #1F6400;\n}\n\n.hover-bg-color {\n  background-color: #1F6400;\n}\n\n.theme-color {\n  color: #1F6400 !important;\n}\n\n.theme-bg-color {\n  background-color: #1F6400;\n}\n\n.theme-second-color {\n  background-color: #1F6400;\n}\n\n;\n\n.theme-border {\n  border: 1px solid #1F6400;\n}\n\n.text-underline {\n  text-decoration: underline;\n\n}\n\n.second-color {\n  color: #1F6400 !important;\n}\n\n.second-bg {\n  background-color: #1F6400;\n}\n\n.bold {\n  font-weight: bold !important;\n}\n\n.w-auto {\n  width: auto;\n}\n\n.w-full {\n  width: 100%;\n}\n\n.w-100vw {\n  width: 100vw;\n}\n\n.h-auto {\n  height: auto;\n}\n\n.h-full {\n  height: 100%;\n}\n\n.h-400px {\n  height: 400px\n}\n\n.h-100vh {\n  height: 100vh;\n}\n\n.relative {\n  position: relative;\n}\n\n.absolute {\n  position: absolute;\n}\n\n.top-0 {\n  top: 0;\n}\n\n.left-0 {\n  left: 0;\n}\n\n.right-0 {\n  right: 0;\n}\n\n.bottom-0 {\n  bottom: 0;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.mx-auto {\n  margin-right: auto !important;\n  margin-left: auto !important;\n}\n\n.my-auto {\n  margin-top: auto !important;\n  margin-bottom: auto !important;\n}\n\n.cursor-pointer {\n  cursor: pointer !important;\n}\n\n.cursor-default {\n  cursor: default !important;\n}\n\n.cursor-zoomIn {\n  cursor: zoom-in;\n}\n\n.cursor-zoomOut {\n  cursor: zoom-out;\n}\n\n.hidden {\n  display: none;\n}\n\n.overflow-hidden {\n  overflow: hidden;\n}\n\n.zeroOpacity {\n  opacity: 0;\n}\n\n.zIndex100 {\n  z-index: 100;\n}\n\n.zIndex-100 {\n  z-index: -100;\n}\n\n.totalOpacity {\n  opacity: 1;\n}\n\n.top50 {\n  top: 50%;\n}\n\n.top100 {\n  top: 70px;\n}\n\n.overflow-visible {\n  overflow: visible;\n}\n\n.rotate-180 {\n  transform: rotate(180deg) !important;\n}\n\n.text-right {\n  text-align: right;\n}\n\n.text-left {\n  text-align: left;\n}\n\n.m-auto {\n  margin: auto;\n}\n\n.mx-8px {\n  margin: 0 8px;\n}\n\n.nothing {}\n\n.right-0 {\n  right: 0;\n}\n\n.left-0 {\n  left: 0;\n}\n\n.text-center {\n  text-align: center;\n}\n\n.mt-10px {\n  margin-top: 10px;\n}\n\n.light {\n  background-color: #ffffff;\n  ;\n}\n\n.grayShadow {\n\n  box-shadow: 0px 0px 2px rgb(0 0 0 / 9%), 0px 1px 5px rgb(0 0 0 / 9%);\n\n}\n\nbutton {\n  background-color: white;\n  padding: 10px 20px;\n  border-radius: 10px;\n  border: none;\n  appearance: none;\n  font-size: 1.3rem;\n  box-shadow: 0px 8px 28px -6px rgba(24, 39, 75, 0.12),\n    0px 18px 88px -4px rgba(24, 39, 75, 0.14);\n  transition: all ease-in 0.1s;\n  cursor: pointer;\n  opacity: 0.9;\n}\n\n.mobile-view {\n  display: none;\n}\n\nbutton:hover {\n  /* transform: scale(1.05); */\n  opacity: 1;\n}\n\nli {\n  list-style: none;\n}\n\na {\n  text-decoration: none;\n  height: fit-content;\n  width: fit-content;\n  margin: 10px;\n}\n\na:hover {\n  opacity: 1;\n  text-decoration: none;\n}\n\n.emptyDiv {\n  flex: 0.8;\n}\n\n.wordBreak {\n  word-break: break-all;\n  text-align: left;\n}\n\n.lds_ringWhite {\n  display: inline-block;\n  position: relative;\n  width: 15px;\n  height: 15px;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 0;\n}\n\n\n.lds_ringWhite div {\n  box-sizing: border-box;\n  display: block;\n  position: absolute;\n  width: 14px;\n  height: 14px;\n  margin: 8px;\n  border: 1px solid #eee !important;\n  border-radius: 50%;\n  animation: lds_ringWhite 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;\n  border-color: #eee transparent transparent transparent !important;\n}\n\n.lds_ringWhite div:nth-child(1) {\n  animation-delay: -0.45s;\n}\n\n.lds_ringWhite div:nth-child(2) {\n  animation-delay: -0.3s;\n}\n\n.lds_ringWhite div:nth-child(3) {\n  animation-delay: -0.15s;\n}\n\n.roundBox {\n  border-radius: 50% !important;\n}\n\n.roundBox img {\n  border-radius: 50% !important;\n}\n\n\n@keyframes lds_ringWhite {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.groupInChatbar {\n  // position: absolute;\n  // left:100%;\n\n\n  position: absolute;\n  bottom: -1px;\n  width: 14px !important;\n  height: 14px !important;\n  /* left: 0px; */\n  display: flex !important;\n  justify-content: center;\n  align-items: center;\n  padding: 2px;\n  // color: #fff;\n  /* background-color: #075b52; */\n  font-size: 11px;\n  border-radius: 50%;\n  background-color: #000000;\n}\n\n\n.groupInChatbarRtl {\n  left: 0 !important;\n  right: unset !important;\n}\n\n.groupInChatbarLtr {\n  left: unset !important;\n  right: 0 !important;\n}\n\n@media only screen and (max-width: 800px) {\n  .mobile-view {\n    display: flex;\n  }\n\n  .emptyDiv {\n    display: none;\n  }\n\n  #chatpage {\n    flex: 1;\n    /* position:absolute;\n  top:0;\n  right:0; */\n    /* background-color: #eee; */\n    /* z-index:900; */\n  }\n\n  .emptyDiv {\n    /* flex: 0.75; */\n  }\n}\n\n@media only screen and (max-width: 650px) {\n  #chatpage {\n    /* margin-top:35px !important;\n    padding-top:20px; */\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
